(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/widget-area.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/widget-area.js');
"use strict";

const {
  useEffect,
  useState,
  useRef
} = React;
const WidgetArea = _ref => {
  let {
    areaName,
    className,
    fallback = null,
    onLoaded = _.noop
  } = _ref;
  const [content, setContent] = useState();
  const widgetRef = useRef(null);
  useEffect(() => {
    svs.core.widget_area.loadArea(areaName, content => {
      setContent(content);
      setTimeout(() => {
        onLoaded(true);
      }, 0);
    });
  }, [areaName, onLoaded]);
  if (content) {
    return React.createElement("div", {
      className: className,
      dangerouslySetInnerHTML: {
        __html: content
      },
      ref: widgetRef
    });
  }
  return fallback;
};
setGlobal('svs.eInstant.lobby.WidgetArea', WidgetArea);

 })(window);